// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:15.192333
var courses = [
    {
        "course_id": "8F318487-4C86-EE11-9987-005056A725AD",
        "course_version": 2,
        "name": "ANA: APRN Pharmacology Today: Safe Prescribing of Opioids",
        "course_type": 1,
        "author_information": "",
        "description": "Designed to fulfill the new DEA requirements, this comprehensive course will provide you with essential knowledge and evidence-based guidance for safe opioid prescribing. Using an interactive, asynchronous format, you will cover the following topics: \r\n\r\n\u2022\tTopic 1. Introduction to Opioids and Prescribing Regulations \r\n\u2022\tTopic 2. Pain Pathways and Opioid Physiology \r\n\u2022\tTopic 3. Pain Assessment and Management \r\n\u2022\tTopic 4. Nonopioid Pain Management \r\n\u2022\tTopic 5. Opioid Pharmacotherapy and Safe Prescribing Practices \r\n\u2022\tTopic 6. Opioid Use Disorder and Associated Risks \r\n\u2022\tTopic 7. Emerging Trends",
        "learning_objectives_html": "<h2>Key Learning Objectives</h2>\r\n<ul>\r\n    <li>Apply DEA\u2011compliant principles for pain assessment, diagnosis, and safe opioid prescribing.</li>\r\n    <li>Integrate pharmacologic and nonpharmacologic therapies to optimize patient\u2011centered pain management.</li>\r\n    <li>Implement evidence\u2011based strategies to prevent, identify, and manage opioid use disorder, overdose, and withdrawal.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "8.0 Contact Hours\r\n<br />\r\n4.0 Pharmacology Hours",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 8.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];